import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { sessionIsUsuarioExterno } from 'src/app/session/store/session.selectors';

@Component({
	selector: 'access',
	templateUrl: './access.component.html',
	styleUrls: ['./access.component.scss']
})
export class AccessComponent {

	isUsuarioExterno$: Observable<boolean>;

	constructor( private store: Store<AppState> ) {
		this.isUsuarioExterno$ = this.store.select( sessionIsUsuarioExterno );
	}

}
